import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconCodeFrame32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconCodeFrame32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M25 6H7a2 2 0 0 0-2 2v1h22V8a2 2 0 0 0-2-2m2 5H5v13a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2zM7 4a4 4 0 0 0-4 4v16a4 4 0 0 0 4 4h18a4 4 0 0 0 4-4V8a4 4 0 0 0-4-4zm5.207 10.293a1 1 0 0 1 0 1.414L9.38 18.535l2.828 2.829a1 1 0 1 1-1.414 1.414l-3.536-3.535-.707-.707.707-.708 3.536-3.535a1 1 0 0 1 1.414 0m7.586 0a1 1 0 0 0 0 1.414l2.828 2.828-2.828 2.829a1 1 0 0 0 1.414 1.414l3.536-3.535.707-.707-.707-.708-3.536-3.535a1 1 0 0 0-1.414 0m-1.516 1.101a1 1 0 0 0-1.867-.717l-2.687 7.002a1 1 0 1 0 1.867.717z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconCodeFrame32);
